import type { PunchOrderFlowDiscountsState } from 'store/punchOrderFlowDiscounts/punchOrderFlowDiscounts.types';

import type { PunchOrderFlowState } from 'store/punchOrderFlowNext/punchOrderFlow.types';
import type { SettingsState } from 'store/settings/settings.reducer';
import type { CreateOrder } from 'types/CreateOrder';
import { getBaseOrderRequestBody } from './getBaseOrderRequestBody.util';

export const getCreateOrderRequestBody = (
  state: {
    punchOrderFlowNext: PunchOrderFlowState;
    punchOrderFlowDiscounts: PunchOrderFlowDiscountsState;
    settings: SettingsState;
  },
  orderCompositionDurationInSeconds: number
): CreateOrder | undefined => {
  const { selectedCustomer: customer, selectedCustomerAddressId } = state.punchOrderFlowNext;
  const baseOrderBody = getBaseOrderRequestBody(state, orderCompositionDurationInSeconds);

  if (!customer?.firstName || !baseOrderBody) {
    return undefined;
  }

  return {
    ...baseOrderBody,
    customer: {
      address: customer.addresses?.find(address => address.id === selectedCustomerAddressId),
      customerCode: customer.customerCode,
      email: customer.email,
      firstName: customer.firstName,
      lastName: customer.lastName,
      phoneNumber: customer.phoneNumber,
      type: customer.type,
    },
  };
};
